import { render, staticRenderFns } from "./NotesTimeline.vue?vue&type=template&id=c40ff1fa&scoped=true&"
import script from "./NotesTimeline.vue?vue&type=script&lang=js&"
export * from "./NotesTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40ff1fa",
  null
  
)

export default component.exports